import React from 'react';
import { 
  Box, 
  Typography, 
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Paper,
  Divider
} from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';

const AttachmentsList = ({ attachments = [] }) => {
  if (!attachments || attachments.length === 0) {
    return null;
  }
  
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' bytes';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };
  
  const getFileIcon = (fileType) => {
    if (fileType.startsWith('image/')) {
      return <ImageIcon />;
    } else if (fileType === 'application/pdf') {
      return <PictureAsPdfIcon />;
    } else {
      return <AttachFileIcon />;
    }
  };
  
  return (
    <Box sx={{ my: 4 }}>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        Attachments ({attachments.length})
      </Typography>
      
      <Paper variant="outlined">
        <List dense>
          {attachments.map((file, index) => (
            <ListItemButton 
              key={index}
              component="a"
              href={file.fileUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemIcon>
                {getFileIcon(file.fileType)}
              </ListItemIcon>
              <ListItemText
                primary={file.fileName}
                secondary={formatFileSize(file.fileSize)}
              />
              <ListItemIcon>
                <DownloadIcon fontSize="small" />
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default AttachmentsList; 